import React from 'react';
import { SmlsButton, SmlsModal } from '@smiles/smiles-ui-kit-react';
import { ModalBody, ModalFooter } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { TangModalHeader } from '../components/TangModalHeader';
import { LoginModal, useLoginModalFlow } from '../context/LoginModalFlowContext';
import { getLink } from '../../utils';
import { ImageModalWhiteSimpleCellphone } from '../assets/ImageModalWhiteSimpleCellphone';
import { ImageModalOrangeCactus } from '../assets/ImageModalOrangeCactus';

export function PreRedoRegisterModal() {
  const { t } = useTranslation('modais');

  const modalFlow = useLoginModalFlow();

  function toggleModal() {
    modalFlow.closeModal(LoginModal.PRE_REDO_REGISTER)
  }

  function handleFirstAccessRedirect () {
    window.location.href = getLink('recuperar/senha');
  }
  
  return (
    <SmlsModal
      type="right"
      isOpen={modalFlow.isModalOpen(LoginModal.PRE_REDO_REGISTER)}
      className="tang-modal"
      toggle={toggleModal}
      defaultHeader={false}
    >
      <TangModalHeader showCloseButton onClose={toggleModal} />
      <ModalBody data-testid="modal-body">
        <div className="modal-content">
          <div> 
            <div className="modal-icon">
              <ImageModalOrangeCactus />
            </div>
            <p className="modal-title">{t('pre_redo_register.title')}</p>
            <p className="modal-subtitle">{t('pre_redo_register.text')}</p>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <SmlsButton text={t('pre_redo_register.hyperlink')} color="hyperlink" onClick={toggleModal} />
        <SmlsButton className="button" text={t('pre_redo_register.button')} onClick={handleFirstAccessRedirect} />
      </ModalFooter>
    </SmlsModal>
  );
}
